import filtersConfig from './filters-config';
import ProductConfiguratorFilter from './product-configurator-filter.vue';

export default {
  name: 'ProductConfiguratorFilters',
  components: {
    ProductConfiguratorFilter
  },
  props: {
    productType: {type: String, required: true},
    mobileVisible: {type: Boolean, default: false}
  },
  data() {
    return {
      filters: filtersConfig[this.productType].map(filter => filter)
    };
  },
  methods: {
    toggleFilterVisibility(filterId) {
      const filter = this.filters.find(filter => filter.id === filterId);
      filter.visible = !filter.visible;
    },
    hideMobileFilters() {
      document.querySelector('.product-configurator-filters').classList.remove('mobile-visible');
    }
  }
};
